export const EXPENSE_CATEGORIES = [
  "Fuel",
  "Hotels",
  "Meals",
  "Supplies",
  "Other",
  "Aerial Imagery",
  "Marketing",
];

const EDIT_WINDOW_MS = 24 * 60 * 60 * 1000;

export const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    return null;
  }
};

export const isAdminUser = () => {
  const user = getCurrentUser();
  return Boolean(user && user.role && user.role_id && user.role_id.name === "Admin");
};

export const getExpenseBasePath = () => (isAdminUser() ? "/admin" : "/user");

// Mirrors the server rule: Admins may always manage, owners only within 24 hours.
// The server re-checks this, so this only governs whether the control is offered.
export const canModifyExpense = (expense) => {
  if (isAdminUser()) return true;

  const user = getCurrentUser();
  if (!user || expense.userId !== user.id) return false;

  return Date.now() - new Date(expense.createdAt).getTime() <= EDIT_WINDOW_MS;
};

// Admins pick from every project; everyone else may only file against work
// they are actually on — directly assigned or via a group. Shape matches
// getAllProjects so callers can treat both the same.
//
// Sorted by name: neither endpoint orders its result, so the dropdowns came
// out in database order. Numeric collation puts "Project 2" before "Project 10".
const byName = (a, b) =>
  String(a?.name ?? "").localeCompare(String(b?.name ?? ""), undefined, {
    numeric: true,
    sensitivity: "base",
  });

export const loadSelectableProjects = async ({ ProjectApi, UserApi }) => {
  const user = getCurrentUser();

  if (!isAdminUser()) {
    if (!user?.id) return [];
    const res = await UserApi.getAssignedProjectsById(user.id);
    const list = res?.data?.data?.projects || [];
    return Array.isArray(list) ? list.filter(Boolean).sort(byName) : [];
  }

  const res = await ProjectApi.getAllProjects();
  const list = res?.data?.data?.projects || res?.data?.data || [];
  return Array.isArray(list) ? [...list].sort(byName) : [];
};
